import { Button, FormControl, Select, MenuItem, Typography, SelectChangeEvent, Box } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { getBrandEmbeds, addVideoToEmbed } from '../../../../api/endpoints'
import axiosInstant from '../../../../api'


export const EmbedSelect = ({ ...props }) => {
  const [embedId, setEmbedId] = useState(null)
  const [embeds, setEmbeds] = useState([])
  //const { isLoading, embeds } = useGetProducts()

  const handleSubmit = async () => {
    let response;
    let payload = { embedId: embedId, fileId: props.videoId }
    response = await axiosInstant.post( addVideoToEmbed(), payload )
    props.onClose()
  }

  const handleSelectEmbed = (e:any) => {
    //setProductId(parseInt(event.target.value, 10))
    setEmbedId(e.target.value)
  }

  // Get list for the add embed dropdown
  const fetchEmbeds = async () => {
    let response;
    response = await axiosInstant.get(getBrandEmbeds(props.brandId, 1000, 1))
    const { data } = response
    if (data.rows.length > 0) {
      setEmbeds(data.rows)
    }
  }

  useEffect(() => {
    fetchEmbeds()
  }, [])

  return (
    <Box>
      <FormControl fullWidth>
        <Select
          id="demo-simple-select"
          onChange={handleSelectEmbed}
          size="small"
          displayEmpty
        >
          <MenuItem value={''}>
            <Typography sx={{ opacity: 0.5 }}>Select Embed</Typography>
          </MenuItem>
          { embeds.map((embed:any, i) => (
            <MenuItem value={embed.id}>{embed.name}</MenuItem>
          ) ) }
        </Select>
      </FormControl>
      <Button onClick={() => {handleSubmit()}} style={{marginTop:'20px'}} size="large" type="submit" variant="contained" disableElevation>
        Submit
      </Button>
    </Box>
  )

}